import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';

import LogController from './LogController';
import DebugController from "./DebugController";
import UserActivityController from "./UserActivityController";
import QbSyncStatusController from "./QbSyncStatusController";
import QbXmlRequestController from "./QbXmlRequestController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('developer', {abstract: true})
            .state('developer.log', {
                url: '/developer/log',
                template: require('./log.html'),
                controller: LogController,
                controllerAs: 'vm',
                data: {title: 'Logs'}
            })
            .state('developer.debug', {
                url: '/developer/debug',
                template: require('./debug.html'),
                controller: DebugController,
                controllerAs: 'vm',
                data: {title: 'Debug'}
            })
            .state('developer.userActivity', {
                url: '/developer/useractivity',
                template: require('./UserActivityView.html'),
                controller: UserActivityController,
                controllerAs: 'vm',
                data: {title: 'User Activity'}
            })
            .state('developer.qbSyncStatus', {
                url: '/developer/qbsyncstatus',
                template: require('./QbSyncStatus.html'),
                controller: QbSyncStatusController,
                controllerAs: 'vm',
                data: {title: 'QB Sync Status'}
            })
            .state('developer.qbXmlRequest', {
                url: '/developer/qbXmlRequest/{guid}',
                template: require('./QbXmlRequest.html'),
                controller: QbXmlRequestController,
                controllerAs: 'vm',
                data: {title: 'QB XML Request'}
            })
    }
}

export default angular.module('app.developer', [])
    .config(Routes)
    .controller({LogController, DebugController})
    .name;
